<template>
  <div
    ref="freePeriods"
    class="free-periods"
  >

    <div class="free-periods-content">
      <div class="head">
        <div class="title">免息期数</div>
        <div class="select">可多选</div>
      </div>

      <div class="content">
        <!-- <div class="periods">3期</div>
        <div class="periods">6期</div>
        <div class="periods" :class="{active:true}">12期</div>
        <div class="periods">24期</div> -->
        <div
          v-for="(item, index) in periods"
          :key="index"
          class="periods"
          :class="{active:item.selected}"
          :clstag="item.clstag"
          @click="onClickSelect(item,index)"
        >{{item.name}}</div>
      </div>
    </div>
    <div class="free-periods-base">

    </div>

  </div>
</template>

<script>
export default {
  name: 'FreePeriods',
  components: {},
  data() {
    return {
      periods: [
        {
          name: '3期',
          selected: false,
          key: 'is3qmx',
          index: '0',
          clstag: 'jr|keycount|jdjr_search_periods|3qi'
        },
        {
          name: '6期',
          selected: false,
          key: 'is6qmx',
          index: '1',
          clstag: 'jr|keycount|jdjr_search_periods|6qi'
        },
        {
          name: '12期',
          selected: false,
          key: 'is12qmx',
          index: '2',
          clstag: 'jr|keycount|jdjr_search_periods|12qi'
        },
        {
          name: '24期',
          selected: false,
          key: 'is24qmx',
          index: '3',
          clstag: 'jr|keycount|jdjr_search_periods|24qi'
        }
      ]
    };
  },
  props: {
    searchData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {},
  created() {
    this.selectItems();
  },
  methods: {
    selectItems() {
      this.periods.map(item => {
        if (String(this.searchData[item.key]) === '1') {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    },
    onClickSelect(item, index) {
      console.log(item);
      if (this.periods && this.periods[index]) {
        this.periods[index].selected = !this.periods[index].selected;
      }

      // this.$emit('onClickFreePeriodsFilter', this.filterList, item);
    },
    onClickReset() {
      this.periods.map(item => {
        item.selected = false;
      });
    }
  },
  mounted() {},
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
.free-periods {
  .free-periods-content {
    width: 100%;

    padding: $rem30 0 $rem30 $rem24;
    .head {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: left;
      margin-bottom: $rem30;
      .title {
        font-family: PingFangSC-Medium;
        font-size: $rem32;
        line-height: $rem32;
        color: #222222;
        letter-spacing: 0;
        margin-right: $rem10;
      }
      .select {
        font-family: PingFangSC-Regular;
        font-size: $rem28;
        color: #999999;
        letter-spacing: 0;
        line-height: $rem32;
      }
    }

    .content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding-right: $rem24;
      //height: $rem68;
      .periods {
        box-sizing: border-box;
        margin-right: $rem26;
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        line-height: $rem26;
        background: #f7f7f7;
        border-radius: $rem100;
        border: 1px solid #f7f7f7;
        padding: $rem19 0;
        &.active {
          color: #d2a35f;
          border: 1px solid #d2a35f;
          //opacity: 0.12;
          background: rgba(194, 148, 81, 0.12);
        }
      }
    }
  }
  .free-periods-base {
    width: 100%;
    background: #f7f7f7;
    height: $rem20;
  }
}
</style>
